// Returns the value of the largest macronutrient for the given row.
export const maxNutrient = (row, unit = 'kJ') => {
  const foo = row[unit]
  return Math.max(...[foo.alcohol, foo.carbs, foo.fat, foo.fibres, foo.protein])
}
